import { useCallback, useState, useEffect } from 'react';

import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { createContainer, useContainer } from 'unstated-next';

import { GET_USER_DATA } from '../../../../../config/apiPaths';
import { getUrlParams, getUrls, processApiPath } from '../../../../../utils/url';
import AdminAuthContainer from '../../../AdminAuthContainer';

interface DataContainerState {
    dataData?: Record<string, any>; // result of the GET_CLASS_DATA_PATH api call
}

type LoadingStatus = 'INITIAL' | 'LOADING' | 'SUCCESS' | 'ERROR';

const useDataContainer = (state: DataContainerState = {}) => {
    console.log('DataContainer');
    const { api } = getUrls();

    const [dataData, setDataData] = useState<any>();

    const { t: tCommon } = useTranslation('common');

    const { authMode } = useContainer(AdminAuthContainer);

    const search = new URLSearchParams(window.location.search);
    const dataUuid = search.get('data_uuid') || window.localStorage.getItem('data_uuid');

    const [getDataStatus, setGetDataStatus] = useState<LoadingStatus>('INITIAL');
    const [errorMessage, setErrorMessage] = useState<string>('');

    const { dataId: dataIdV1 } = useParams<{ dataId?: string }>();
    const { data_id: dataIdV2 } = getUrlParams();
    const dataId = dataIdV1 || dataIdV2 || '';

    const returnErrorMessage = useCallback(
        (error: any): string => {
            console.error(error);
            return tCommon('errorMessage');
        },
        [tCommon]
    );

    const getDataDataCall = useCallback(async () => {
        const { data } = await axios.get(
            processApiPath(GET_USER_DATA, undefined, {
                data_uuid: dataUuid!,
                data_id: dataId,
                auth_mode: authMode
            })
        );

        if (data?.success === false) {
            throw Error(data?.error);
        }
        return data;
    }, [dataUuid, dataId, authMode]);

    const getData = useCallback(async () => {
        setGetDataStatus('LOADING');

        try {
            const data = state.dataData ?? (await getDataDataCall());

            setDataData(data);
            setGetDataStatus('SUCCESS');
        } catch (err) {
            const errorMsg = returnErrorMessage(err);
            setErrorMessage(errorMsg);
            setGetDataStatus('ERROR');
        }
    }, [state.dataData, getDataDataCall, returnErrorMessage]);

    useEffect(() => {
        if (dataId && dataUuid) {
            getData();
        }
    }, [dataId, getData, dataUuid]);

    return {
        dataId,
        api,
        dataData,
        getDataStatus,
        errorMessage
    };
};

const DataContainer = createContainer(useDataContainer);

export default DataContainer;
